/**
 * Toolkit shell tab IA (field-edition 5b-1):
 * Feed Tracker · Planting · Printable Map
 */

export const TOOLKIT_TAB_FEED = 'feed';
export const TOOLKIT_TAB_PLANTING = 'planting';
export const TOOLKIT_TAB_PRINTABLE = 'printable';

export const TOOLKIT_FEED_PATH = '/toolkit/feed-management';
export const TOOLKIT_PLANTING_PATH = '/toolkit/planting-assistant';
export const TOOLKIT_PRINTABLE_PATH = '/toolkit/printable-map';
export const TOOLKIT_DEFAULT_PATH = TOOLKIT_FEED_PATH;

/** @deprecated Prefer TOOLKIT_PLANTING_PATH */
export const TOOLKIT_PLANTING_ASSISTANT_PATH = TOOLKIT_PLANTING_PATH;

export const TOOLKIT_PLANTING_PLAN_NEW_PATH = `${TOOLKIT_PLANTING_PATH}/plan/new`;

export const TOOLKIT_SHELL_TABS = [
  { id: TOOLKIT_TAB_FEED, label: 'Feed Tracker', path: TOOLKIT_FEED_PATH },
  { id: TOOLKIT_TAB_PLANTING, label: 'Planting', path: TOOLKIT_PLANTING_PATH },
  { id: TOOLKIT_TAB_PRINTABLE, label: 'Printable Map', path: TOOLKIT_PRINTABLE_PATH },
];

function normalizePathname(pathname = '') {
  return String(pathname || '').replace(/\/+$/, '') || '/';
}

export function isPlantingAssistantPath(pathname = '') {
  const path = normalizePathname(pathname);
  return (
    path === TOOLKIT_PLANTING_PATH
    || path.startsWith(`${TOOLKIT_PLANTING_PATH}/`)
    || path === '/toolkit/area-calculator'
    || path.startsWith('/toolkit/area-calculator/')
  );
}

/**
 * Build a planting plan flow location.
 * @param {string|number|'new'} planId
 * @param {string} [step]
 * @returns {{ pathname: string, search?: string } | string}
 */
export function plantingPlanLocation(planId = 'new', step) {
  const id = planId === 'new' || planId == null || planId === ''
    ? 'new'
    : String(planId);
  const pathname = id === 'new'
    ? TOOLKIT_PLANTING_PLAN_NEW_PATH
    : `${TOOLKIT_PLANTING_PATH}/plan/${encodeURIComponent(id)}`;
  if (!step) return { pathname };
  return { pathname, search: `?step=${encodeURIComponent(String(step))}` };
}

/** @deprecated Prefer plantingPlanLocation for navigate(); kept for string assertions. */
export function plantingPlanPath(planId = 'new', step) {
  const loc = plantingPlanLocation(planId, step);
  return loc.search ? `${loc.pathname}${loc.search}` : loc.pathname;
}

export function parseToolkitTab(pathname = '') {
  const path = normalizePathname(pathname);
  if (isPlantingAssistantPath(path)) {
    return TOOLKIT_TAB_PLANTING;
  }
  if (path === TOOLKIT_PRINTABLE_PATH || path.startsWith(`${TOOLKIT_PRINTABLE_PATH}/`)) {
    return TOOLKIT_TAB_PRINTABLE;
  }
  return TOOLKIT_TAB_FEED;
}

export function toolkitPathForTab(tabId) {
  const match = TOOLKIT_SHELL_TABS.find((tab) => tab.id === tabId);
  return match?.path || TOOLKIT_DEFAULT_PATH;
}
